module.exports = __webpack_public_path__ + "img/guanyuwomen.e6329c16.png";